import { render } from "./MobileDetail.vue?vue&type=template&id=0a2249af&scoped=true&ts=true"
import script from "./MobileDetail.vue?vue&type=script&lang=ts"
export * from "./MobileDetail.vue?vue&type=script&lang=ts"

import "./MobileDetail.vue?vue&type=style&index=0&id=0a2249af&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2249af"]])

export default __exports__